import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Point, Polygon, State, settings, DRAW_MODES } from '@pixi/core';
import { Container } from '@pixi/display';
import { MeshBatchUvs } from './MeshBatchUvs.mjs';
var tempPoint = new Point();
var tempPolygon = new Polygon();
var _Mesh = /*#__PURE__*/function (_Container) {
  _inherits(_Mesh, _Container);
  var _super = _createSuper(_Mesh);
  function _Mesh(geometry, shader, state) {
    var _this;
    var drawMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DRAW_MODES.TRIANGLES;
    _classCallCheck(this, _Mesh);
    _this = _super.call(this);
    _this.geometry = geometry;
    _this.shader = shader;
    _this.state = state || State.for2d();
    _this.drawMode = drawMode;
    _this.start = 0;
    _this.size = 0;
    _this.uvs = null;
    _this.indices = null;
    _this.vertexData = new Float32Array(1);
    _this.vertexDirty = -1;
    _this._transformID = -1;
    _this._roundPixels = settings.ROUND_PIXELS;
    _this.batchUvs = null;
    return _this;
  }
  _createClass(_Mesh, [{
    key: "geometry",
    get: function get() {
      return this._geometry;
    },
    set: function set(value) {
      if (this._geometry === value) {
        return;
      }
      if (this._geometry) {
        this._geometry.refCount--;
        if (this._geometry.refCount === 0) {
          this._geometry.dispose();
        }
      }
      this._geometry = value;
      if (this._geometry) {
        this._geometry.refCount++;
      }
      this.vertexDirty = -1;
    }
  }, {
    key: "uvBuffer",
    get: function get() {
      return this.geometry.buffers[1];
    }
  }, {
    key: "verticesBuffer",
    get: function get() {
      return this.geometry.buffers[0];
    }
  }, {
    key: "material",
    get: function get() {
      return this.shader;
    },
    set: function set(value) {
      this.shader = value;
    }
  }, {
    key: "blendMode",
    get: function get() {
      return this.state.blendMode;
    },
    set: function set(value) {
      this.state.blendMode = value;
    }
  }, {
    key: "roundPixels",
    get: function get() {
      return this._roundPixels;
    },
    set: function set(value) {
      if (this._roundPixels !== value) {
        this._transformID = -1;
      }
      this._roundPixels = value;
    }
  }, {
    key: "tint",
    get: function get() {
      return "tint" in this.shader ? this.shader.tint : null;
    },
    set: function set(value) {
      this.shader.tint = value;
    }
  }, {
    key: "texture",
    get: function get() {
      return "texture" in this.shader ? this.shader.texture : null;
    },
    set: function set(value) {
      this.shader.texture = value;
    }
  }, {
    key: "_render",
    value: function _render(renderer) {
      var vertices = this.geometry.buffers[0].data;
      var shader = this.shader;
      if (shader.batchable && this.drawMode === DRAW_MODES.TRIANGLES && vertices.length < _Mesh.BATCHABLE_SIZE * 2) {
        this._renderToBatch(renderer);
      } else {
        this._renderDefault(renderer);
      }
    }
  }, {
    key: "_renderDefault",
    value: function _renderDefault(renderer) {
      var shader = this.shader;
      shader.alpha = this.worldAlpha;
      if (shader.update) {
        shader.update();
      }
      renderer.batch.flush();
      shader.uniforms.translationMatrix = this.transform.worldTransform.toArray(true);
      renderer.shader.bind(shader);
      renderer.state.set(this.state);
      renderer.geometry.bind(this.geometry, shader);
      renderer.geometry.draw(this.drawMode, this.size, this.start, this.geometry.instanceCount);
    }
  }, {
    key: "_renderToBatch",
    value: function _renderToBatch(renderer) {
      var geometry = this.geometry;
      var shader = this.shader;
      if (shader.uvMatrix) {
        shader.uvMatrix.update();
        this.calculateUvs();
      }
      this.calculateVertices();
      this.indices = geometry.indexBuffer.data;
      this._tintRGB = shader._tintRGB;
      this._texture = shader.texture;
      var pluginName = this.material.pluginName;
      renderer.batch.setObjectRenderer(renderer.plugins[pluginName]);
      renderer.plugins[pluginName].render(this);
    }
  }, {
    key: "calculateVertices",
    value: function calculateVertices() {
      var geometry = this.geometry;
      var verticesBuffer = geometry.buffers[0];
      var vertices = verticesBuffer.data;
      var vertexDirtyId = verticesBuffer._updateID;
      if (vertexDirtyId === this.vertexDirty && this._transformID === this.transform._worldID) {
        return;
      }
      this._transformID = this.transform._worldID;
      if (this.vertexData.length !== vertices.length) {
        this.vertexData = new Float32Array(vertices.length);
      }
      var wt = this.transform.worldTransform;
      var a = wt.a;
      var b = wt.b;
      var c = wt.c;
      var d = wt.d;
      var tx = wt.tx;
      var ty = wt.ty;
      var vertexData = this.vertexData;
      for (var i = 0; i < vertexData.length / 2; i++) {
        var x = vertices[i * 2];
        var y = vertices[i * 2 + 1];
        vertexData[i * 2] = a * x + c * y + tx;
        vertexData[i * 2 + 1] = b * x + d * y + ty;
      }
      if (this._roundPixels) {
        var resolution = settings.RESOLUTION;
        for (var _i = 0; _i < vertexData.length; ++_i) {
          vertexData[_i] = Math.round(vertexData[_i] * resolution) / resolution;
        }
      }
      this.vertexDirty = vertexDirtyId;
    }
  }, {
    key: "calculateUvs",
    value: function calculateUvs() {
      var geomUvs = this.geometry.buffers[1];
      var shader = this.shader;
      if (!shader.uvMatrix.isSimple) {
        if (!this.batchUvs) {
          this.batchUvs = new MeshBatchUvs(geomUvs, shader.uvMatrix);
        }
        this.batchUvs.update();
        this.uvs = this.batchUvs.data;
      } else {
        this.uvs = geomUvs.data;
      }
    }
  }, {
    key: "_calculateBounds",
    value: function _calculateBounds() {
      this.calculateVertices();
      this._bounds.addVertexData(this.vertexData, 0, this.vertexData.length);
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(point) {
      if (!this.getBounds().contains(point.x, point.y)) {
        return false;
      }
      this.worldTransform.applyInverse(point, tempPoint);
      var vertices = this.geometry.getBuffer("aVertexPosition").data;
      var points = tempPolygon.points;
      var indices = this.geometry.getIndex().data;
      var len = indices.length;
      var step = this.drawMode === 4 ? 3 : 1;
      for (var i = 0; i + 2 < len; i += step) {
        var ind0 = indices[i] * 2;
        var ind1 = indices[i + 1] * 2;
        var ind2 = indices[i + 2] * 2;
        points[0] = vertices[ind0];
        points[1] = vertices[ind0 + 1];
        points[2] = vertices[ind1];
        points[3] = vertices[ind1 + 1];
        points[4] = vertices[ind2];
        points[5] = vertices[ind2 + 1];
        if (tempPolygon.contains(tempPoint.x, tempPoint.y)) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "destroy",
    value: function destroy(options) {
      _get(_getPrototypeOf(_Mesh.prototype), "destroy", this).call(this, options);
      if (this._cachedTexture) {
        this._cachedTexture.destroy();
        this._cachedTexture = null;
      }
      this.geometry = null;
      this.shader = null;
      this.state = null;
      this.uvs = null;
      this.indices = null;
      this.vertexData = null;
    }
  }]);
  return _Mesh;
}(Container);
var Mesh = _Mesh;
Mesh.BATCHABLE_SIZE = 100;
export { Mesh };